/* eslint-disable @typescript-eslint/no-unused-vars */
import QRCode from 'qrcode'

import BND from '../assets/ccy/bnd.svg'
import CNY from '../assets/ccy/cny.svg'
import IDR from '../assets/ccy/idr.svg'
import INR from '../assets/ccy/inr.svg'
import KHR from '../assets/ccy/khr.svg'
import LAK from '../assets/ccy/lak.svg'
import MMK from '../assets/ccy/mmk.svg'
import MYR from '../assets/ccy/myr.svg'
import PHP from '../assets/ccy/php.svg'
import SGD from '../assets/ccy/sgd.svg'
import THB from '../assets/ccy/thb.svg'
import USD from '../assets/ccy/usd.svg'
import VND from '../assets/ccy/vnd.svg'
import EUR from '../assets/ccy/eur.svg'
import CZK from '../assets/ccy/czk.svg'
import AUD from '../assets/ccy/aud.svg'
const ccy: Record<string, string> = {
  '096': BND,
  '156': CNY,
  '360': IDR,
  '356': INR,
  '116': KHR,
  '418': LAK,
  '104': MMK,
  '458': MYR,
  '608': PHP,
  '702': SGD,
  '764': THB,
  '840': USD,
  '704': VND,
  '978': EUR,
  '203': CZK,
  '036': AUD,
}

export class QRCodeCanvasFactory {
  private qrText: string
  private currency: string
  private bakongAccount: string
  private labelName: string

  constructor(qrText: string, currency: string, labelName: string= '', bakongAccount: string = '') {
    this.qrText = qrText
    this.currency = currency
    this.bakongAccount= bakongAccount
    this.labelName = labelName
  }

  async createQR() {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d') as CanvasRenderingContext2D
    // Generate QR code
    const qrcode = await QRCode.toDataURL(this.qrText, { width: 575.211, margin: 0 })

    return { qrcode, currency: this.currency}
  }
}